"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_GrimdinesCurse_OnTurnStartedEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Ability_GrimdinesCurse_OnTurnStartedEventHandlerScript = class Ability_GrimdinesCurse_OnTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.TurnStarted) {
            return;
        }
        const enemies = container.selectTargets(handler.subject, Target_1.Target.AllEnemies);
        for (const enemy of enemies) {
            const healthDecrease = container.getPercentOfBaseHealth(enemy, 2);
            container.applyDebuff({
                sequence,
                attackerId: handler.subject,
                targetId: enemy,
                duration: Duration_1.Duration.Permanent,
                effect: new __1.MaxAttributeDecreaseEffectArgs(__1.AttributeType.Health, healthDecrease)
            });
        }
    }
};
Ability_GrimdinesCurse_OnTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_GrimdinesCurse_OnTurnStarted")
], Ability_GrimdinesCurse_OnTurnStartedEventHandlerScript);
exports.Ability_GrimdinesCurse_OnTurnStartedEventHandlerScript = Ability_GrimdinesCurse_OnTurnStartedEventHandlerScript;
